import { render, staticRenderFns } from "./GerarCteComplementarForm.vue?vue&type=template&id=353bf104"
import script from "./GerarCteComplementarForm.vue?vue&type=script&lang=js"
export * from "./GerarCteComplementarForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports